import * as zod from 'zod';

import { ContentBlock } from './contentBlock';

export const AgentMessageRole = zod.enum(['user', 'assistant', 'tool']);
export type AgentMessageRole = zod.infer<typeof AgentMessageRole>;

export const MessageUsage = zod.object({
  inputTokens: zod.number().int().nonnegative(),
  outputTokens: zod.number().int().nonnegative(),
  cacheReadTokens: zod.number().int().nonnegative().optional(),
  cacheCreationTokens: zod.number().int().nonnegative().optional(),
});
export type MessageUsage = zod.infer<typeof MessageUsage>;

export const AgentMessageData = zod.object({
  id: zod.string(),
  sessionID: zod.string(),
  turnID: zod.string().nullable(),
  sequence: zod.number().int().positive(),
  role: AgentMessageRole,
  content: zod.array(ContentBlock),
  model: zod.string().nullable(),
  usage: MessageUsage.nullable(),
  stopReason: zod.string().nullable(),
  actionButtons: zod.unknown().nullable(),
  createdAt: zod.string(),
});

export type AgentMessageData = zod.infer<typeof AgentMessageData>;

export const AgentMessageCreateInput = zod.object({
  sessionID: zod.string(),
  turnID: zod.string().nullable().optional(),
  role: AgentMessageRole,
  content: zod.array(ContentBlock),
  model: zod.string().nullable().optional(),
  usage: MessageUsage.nullable().optional(),
  stopReason: zod.string().nullable().optional(),
  actionButtons: zod.unknown().nullable().optional(),
});

export type AgentMessageCreateInput = zod.infer<typeof AgentMessageCreateInput>;
